import type { ContactDetailsFields } from '@features/page/hooks/use-contact-details'
import { PrivacyCookieCheckbox } from '@vp/contact-channels'
import { Box } from '@vp/swan'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'

interface PrivacyCookieFieldProps {
  control: Control<ContactDetailsFields>
}

export const PrivacyCookieField = ({ control }: PrivacyCookieFieldProps) => {
  const handlePrivacyPolicyClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement
    if (target.tagName !== 'A') return
  }

  return (
    <Box data-testid="privacy-checkbox-field" onClick={handlePrivacyPolicyClick}>
      <Controller name="optInRecording" control={control} render={({ field }) => <PrivacyCookieCheckbox checked={field.value} onChange={field.onChange} />} />
    </Box>
  )
}
